import React from 'react';
import { Box } from '@mui/material';
import type { StatChipProps } from '../riego.types';
import {
  CHIP_BORDER_RADIUS, CHIP_FONT_SIZE, CHIP_PADDING_X, CHIP_PADDING_Y,
} from '../riego.constants';

const StatChip: React.FC<StatChipProps> = ({ value, label, accent }) => {
  const accented = Boolean(accent);
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 0.5,
        px: CHIP_PADDING_X,
        py: CHIP_PADDING_Y,
        borderRadius: CHIP_BORDER_RADIUS,
        fontSize: CHIP_FONT_SIZE,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        backgroundColor: accented ? 'transparent' : 'grey.100',
        border: accented ? '1px solid' : 'none',
        borderColor: accented ? `${accent}.main` : 'transparent',
        color: accented ? `${accent}.main` : 'text.secondary',
      }}
    >
      <Box component="span" sx={{ fontWeight: 700 }}>{value}</Box>
      <Box component="span">{label}</Box>
    </Box>
  );
};

export default StatChip;
